<script setup lang="ts">
import { sizeNormalize } from "~/common/helpers/size-adapter";
import type { SizeTrimmed } from "~/common/interfaces/size-trimmed";

const props = defineProps({
	sizes: {
		type: Array as PropType<SizeTrimmed[]>,
		default () {
			return [];
		}
	}
});

const sizesAdapted = computed(() => props.sizes.map(size => sizeNormalize(size)));

const { ids, switchQueryId } = useQueryValueIdMapping("sizes");
</script>

<template>
	<ul class="pt-3 flex flex-wrap gap-3 max-w-[256px]">
		<li v-for="{id, name} in sizesAdapted" :key="id">
			<CommonCheckboxTag
				:model-value="ids.includes(id)"
				@update:model-value="switchQueryId(id)"
			>
				{{ name }}
			</CommonCheckboxTag>
		</li>
	</ul>
</template>
